"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memo = void 0;
const empty = Symbol();
const primitives = new Set([
    'undefined',
    'boolean',
    'number',
    'bigint',
    'string',
    'symbol',
]);
function isPrimitive(v) {
    return primitives.has(typeof v) || v === null;
}
/**
 * Memoize a function based on its input parameters
 *
 * Input parameters are compared using exact comparison - no structural equality is used.
 *
 * Complex input parameters are stored using WeakMap, so they will be garbage collected if they are no longer referenced.
 *
 * Maps are not truncated, so they will grow indefinitely. Due to the above, this is only a problem for primitive input parameters.
 */
function memo(fn) {
    const cache = { item: empty };
    function get(args) {
        let node = cache;
        for (const arg of args) {
            if (isPrimitive(arg)) {
                if (!node.primitive) {
                    node.primitive = new Map();
                }
                const map = node.primitive;
                node = map.get(arg) ?? { item: empty };
                map.set(arg, node);
            }
            else {
                if (!node.complex) {
                    node.complex = new WeakMap();
                }
                const map = node.complex;
                node = map.get(arg) ?? { item: empty };
                map.set(arg, node);
            }
        }
        return node;
    }
    const output = Object.assign(function memoised(...args) {
        output.callCount += 1;
        const cache = get(args);
        if (cache.item !== empty) {
            return cache.item;
        }
        output.runCount += 1;
        const result = fn(...args);
        cache.item = result;
        return result;
    }, { callCount: 0, runCount: 0 });
    return output;
}
exports.memo = memo;
//# sourceMappingURL=memo.js.map